import { useAuth } from "@/features/auth/hooks/useAuth";
import type { Organization } from "@/features/auth/types/organization.type";

export const useOrganization = (): Organization | null => {
  const { organization } = useAuth();
  return organization;
};
